var viewer_figure_default = {
  "figure": "k4d5f"
};
export {
  viewer_figure_default as default
};
//# sourceMappingURL=viewer-figure-scss.js.map
